import { Box, useTheme } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import React, { FC, useState } from 'react'
import { NucbaTheme } from '../../styles'
import { BasicComponentProps } from '../../common/types'
import { NucBoomerang } from '../../icons'

type ToggleButtonProps = {
  toggle: () => void
  /** @default to-right */
  direction?: 'to-left' | 'to-right'
}

const ToggleButton: FC<
  Omit<BasicComponentProps<ToggleButtonProps>, 'onClick'>
> = ({ toggle, direction = 'to-right', ...rest }) => {
  const { colors } = useTheme<NucbaTheme>()

  const [rotate, setRotate] = useState(direction === 'to-right' ? -180 : 0)

  return (
    <Box
      as={motion.div}
      animate={{
        rotate,
      }}
      initial={{
        rotate,
      }}
      bg={colors.nucba.primary}
      borderRadius='full'
      w={8}
      h={8}
      display='inline-flex'
      alignItems='center'
      justifyContent='center'
      boxShadow=' 0px 0px 6px 2px rgba(255, 0, 92, 0.3)'
      cursor='pointer'
      userSelect='none'
      onClick={() => {
        setRotate(rotate === -180 ? 0 : -180)
        toggle()
      }}
      {...rest}
    >
      <NucBoomerang width='20' height='20' />
    </Box>
  )
}

export default ToggleButton
